import { render, staticRenderFns } from "./rewardThemePackEdit_bak.vue?vue&type=template&id=566fed1a&scoped=true&"
import script from "./rewardThemePackEdit_bak.vue?vue&type=script&lang=js&"
export * from "./rewardThemePackEdit_bak.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566fed1a",
  null
  
)

export default component.exports